import { addCache } from 'api/caching'
import { getCerebroHeaders } from 'api/Cerebro/headers'
import {
    CerebroApiOptions,
    CerebroPaginatedResponse,
    CerebroResourceResponse,
} from 'api/Cerebro/types'
import { orgScopedApiClient } from 'api/orgScopedClient'
import { Report } from 'types'

import { BannerRequestBody } from './types'

export const getProductAdFacts = (
    params: BannerRequestBody,
    options: CerebroApiOptions = {}
): Promise<CerebroPaginatedResponse<any>> =>
    orgScopedApiClient.post(`/api/product_ad_facts/aggregate/banner/`, params, {
        headers: getCerebroHeaders(options.headers),
    })
addCache(getProductAdFacts)

const getProductAdWithFacts = (
    params: BannerRequestBody,
    options: CerebroApiOptions = {}
): Promise<CerebroPaginatedResponse<any>> =>
    orgScopedApiClient.post(
        `/api/product_ad_only_facts/aggregate/banner/`,
        params,
        {
            headers: getCerebroHeaders(options.headers),
        }
    )
addCache(getProductAdWithFacts)

export const asyncUpdateProductAdFacts = (
    data: any,
    params: BannerRequestBody,
    options: CerebroApiOptions = {}
): Promise<CerebroResourceResponse<any>> =>
    orgScopedApiClient.patch(
        `/api/product_ad_facts/aggregate/banner/mutate/`,
        data,
        {
            params: { ...params, metrics: null },
            headers: getCerebroHeaders(options.headers),
        }
    )

export const getProductAdFactsExport = (
    params: BannerRequestBody
): Promise<CerebroResourceResponse<Report>> =>
    orgScopedApiClient.post(
        `/api/product_ad_facts/aggregate/banner/export/`,
        params
    )
